document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('zp-configurator-form');
  if (!form) return;

  var farbeInputs = document.querySelectorAll('input[name="zp-farbe"]');
  var varianteInputs = document.querySelectorAll('input[name="zp-variante"]');
  var hoeheInputs = document.querySelectorAll('input[name="zp-hoehe"]');
  var laenge = document.getElementById('zp-laenge');
  var gartentor = document.getElementById('zp-gartentor');
  var eckpfosten = document.getElementById('zp-eckpfosten');
  var montageInputs = document.querySelectorAll('input[name="zp-montage"]');
  var nameField = document.getElementById('zp-name');
  var emailField = document.getElementById('zp-email');
  var telefonField = document.getElementById('zp-telefon');
  var contactBody = document.getElementById('zp-contact-body');

  var outFarbe = document.getElementById('zp-result-farbe');
  var outVariante = document.getElementById('zp-result-variante');
  var outHoehe = document.getElementById('zp-result-hoehe');
  var outLaenge = document.getElementById('zp-result-laenge');
  var outGartentor = document.getElementById('zp-result-gartentor');
  var outEckpfosten = document.getElementById('zp-result-eckpfosten');
  var outMontage = document.getElementById('zp-result-montage');
  var outName = document.getElementById('zp-result-name');
  var outEmail = document.getElementById('zp-result-email');
  var outTelefon = document.getElementById('zp-result-telefon');

  function getCheckedValue(nodeList, fallback) {
    var checked = Array.from(nodeList).find(function (input) {
      return input.checked;
    });
    return checked ? checked.value : fallback;
  }

  function safeValue(el, fallback) {
    if (!el || !el.value) return fallback;
    return el.value;
  }

  function updateChoiceStates() {
    var colorCards = document.querySelectorAll('.zp-configurator__choice-card');
    colorCards.forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      if (input && input.checked) {
        card.classList.add('is-selected');
      } else {
        card.classList.remove('is-selected');
      }
    });

    var heightPills = document.querySelectorAll('.zp-configurator__choice-pill');
    heightPills.forEach(function (pill) {
      var input = pill.querySelector('input[type="radio"]');
      if (input && input.checked) {
        pill.classList.add('is-selected');
      } else {
        pill.classList.remove('is-selected');
      }
    });
  }

  function updateSummary() {
    var farbe = getCheckedValue(farbeInputs, 'Anthrazit');
    var variante = getCheckedValue(varianteInputs, '6/5/6');
    var hoehe = getCheckedValue(hoeheInputs, '163 cm');
    var laengeVal = safeValue(laenge, '-');
    var gartentorVal = safeValue(gartentor, 'Nein');
    var eckpfostenVal = safeValue(eckpfosten, '0');
    var montage = getCheckedValue(montageInputs, 'Nein');
    var nameVal = safeValue(nameField, '-');
    var emailVal = safeValue(emailField, '-');
    var telefonVal = safeValue(telefonField, '-');

    if (outFarbe) outFarbe.textContent = farbe;
    if (outVariante) outVariante.textContent = variante;
    if (outHoehe) outHoehe.textContent = hoehe;
    if (outLaenge) outLaenge.textContent = laengeVal;
    if (outGartentor) outGartentor.textContent = gartentorVal;
    if (outEckpfosten) outEckpfosten.textContent = eckpfostenVal;
    if (outMontage) outMontage.textContent = montage;
    if (outName) outName.textContent = nameVal;
    if (outEmail) outEmail.textContent = emailVal;
    if (outTelefon) outTelefon.textContent = telefonVal;

    if (contactBody) {
      contactBody.value =
        'Neue Anfrage über den Zaun-Konfigurator\n\n' +
        'Produkt: Doppelstabmattenzaun\n' +
        'Variante: ' + variante + '\n' +
        'Farbe: ' + farbe + '\n' +
        'Höhe: ' + hoehe + '\n' +
        'Zaunlänge: ' + laengeVal + ' m\n' +
        'Montageart: Einbetonieren\n' +
        'Pfosten: Pfosten mit Abdeckleiste\n' +
        'Gartentor: ' + gartentorVal + '\n' +
        'Eckpfosten: ' + eckpfostenVal + '\n' +
        'Montage gewünscht: ' + montage;
    }

    updateChoiceStates();
  }

  farbeInputs.forEach(function (input) {
    input.addEventListener('change', updateSummary);
  });

  varianteInputs.forEach(function (input) {
    input.addEventListener('change', updateSummary);
  });

  hoeheInputs.forEach(function (input) {
    input.addEventListener('change', updateSummary);
  });

  montageInputs.forEach(function (input) {
    input.addEventListener('change', updateSummary);
  });

  [laenge, gartentor, eckpfosten, nameField, emailField, telefonField].forEach(function (field) {
    if (!field) return;
    field.addEventListener('input', updateSummary);
    field.addEventListener('change', updateSummary);
  });

  form.addEventListener('submit', function () {
    updateSummary();
  });

  updateSummary();

  var successBox = document.querySelector('.zp-configurator__success');
  var modal = document.getElementById('zp-success-modal');
  var closeBtn = document.getElementById('zp-success-close');

  if (successBox && modal) {
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', function () {
      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
    });
  }

  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.classList.remove('is-visible');
        modal.setAttribute('aria-hidden', 'true');
      }
    });
  }
});